import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPackageCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5 6.27783L9.99997 11.0001M9.99997 11.0001L1.49997 6.27783M9.99997 11.0001L10 20.5001M12 19.889L10.777 20.5684C10.4934 20.726 10.3516 20.8047 10.2015 20.8356C10.0685 20.863 9.93146 20.863 9.79855 20.8356C9.64838 20.8047 9.50658 20.726 9.22297 20.5684L1.82297 16.4573C1.52346 16.2909 1.37368 16.2077 1.26463 16.0893C1.16816 15.9847 1.09515 15.8606 1.05048 15.7254C1 15.5726 1 15.4013 1 15.0586V6.94153C1 6.59889 1 6.42757 1.05048 6.27477C1.09515 6.13959 1.16816 6.01551 1.26463 5.91082C1.37368 5.79248 1.52345 5.70928 1.82297 5.54288L9.22297 1.43177C9.50657 1.27421 9.64838 1.19543 9.79855 1.16454C9.93146 1.13721 10.0685 1.13721 10.2015 1.16454C10.3516 1.19543 10.4934 1.27421 10.777 1.43177L18.177 5.54288C18.4766 5.70928 18.6263 5.79248 18.7354 5.91082C18.8318 6.01551 18.9049 6.13959 18.9495 6.27477C19 6.42757 19 6.59889 19 6.94153L19 11.5001M5.5 3.50008L14.5 8.50008M14 17.0001L16 19.0001L20 15.0001",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPackageCheck;
